export default "__VITE_ASSET__kkYZT$Yb__"